import * as React from "react";
export class DetailItem extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-dialog-reality-check__item", "data-uat": "reality-check-item" },
            React.createElement("span", { className: "rj-dialog-reality-check__item-name", "data-uat": "reality-check-item-name" }, this.props.title),
            React.createElement("span", { className: "rj-dialog-reality-check__item-indicator", "data-uat": "reality-check-item-indicator" }, this.props.indicator)));
    }
}
//# sourceMappingURL=DetailItem.js.map